import * as posActions from "../../lib/posActions";
import * as routeHelpers from "../../lib/routeHelpers";
import OutlineButton from "../OutlineButton";
import PaymentsMethodHeader from "../PaymentMethodsHeader";
import React from "react";
import styles from "./OtherPaymentMethods.module.css";
import {useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../lib/hooks";

const strings = {
    otherPaymentMethods: "Other Payment Options",
    fundraiser: "Fundraiser",
    ezCaterPickup: "EzCater Pickup",
    ezCaterDelivery: "EzCater Delivery",
};

export function OtherPaymentMethods() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const supportedExternalTenders = useAppSelector(
        (state) => state.pos.store.supportedExternalTenders,
    );

    return (
        <div>
            <PaymentsMethodHeader
                backPromptLabel={strings.otherPaymentMethods}
                to={routeHelpers.payment()}
            />
            <div className={styles.paymentMethodOptionsContainer}>
                <OutlineButton
                    className={styles.paymentMethodOptionButton}
                    label={strings.fundraiser}
                    onClick={() => {
                        navigate(routeHelpers.fundraiser());
                    }}
                />
                <OutlineButton
                    className={styles.paymentMethodOptionButton}
                    label={strings.ezCaterPickup}
                    onClick={() => {
                        dispatch(
                            posActions.setCurrentOrderEzCaterOrderType(
                                "pickup",
                            ),
                        );
                        navigate(routeHelpers.ezCater());
                    }}
                />
                <OutlineButton
                    className={styles.paymentMethodOptionButton}
                    label={strings.ezCaterDelivery}
                    onClick={() => {
                        dispatch(
                            posActions.setCurrentOrderEzCaterOrderType(
                                "delivery",
                            ),
                        );
                        navigate(routeHelpers.ezCater());
                    }}
                />
                {supportedExternalTenders.map((tenderName, i) => {
                    return (
                        <OutlineButton
                            key={i}
                            className={styles.paymentMethodOptionButton}
                            label={tenderName}
                            onClick={() => {
                                navigate(
                                    routeHelpers.externalTender(tenderName),
                                );
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
}
